module.exports = __webpack_public_path__ + "img/s.850aec79.svg";